import React from 'react';
import { FileText } from 'lucide-react';
export function FaqSection() {
  const faqs = [{
    q: '¿Funciona si mi pareja es cerrada?',
    a: 'Específicamente diseñado para eso. El misterio es el anzuelo; la conexión es el resultado inevitable.'
  }, {
    q: '¿Cuánto tiempo toma?',
    a: 'Cada caso toma entre 15 y 20 minutos de análisis.'
  }, {
    q: '¿Es físico o digital?',
    a: 'Es un PDF de descarga inmediata para que jueguen hoy mismo.'
  }];
  return <section className="py-24 bg-noir-bg border-b border-noir-border relative" data-id="element-48">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl" data-id="element-49">
        <h2 className="text-3xl font-mono font-bold text-noir-text mb-12 text-center uppercase" data-id="element-50">
          Fichas de <span className="text-noir-alert" data-id="element-51">Interrogado</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-52">
          {faqs.map((faq, index) => <div key={index} className="bg-noir-paper border border-[#D7CCC8] p-6 rounded-sm shadow-md relative transform transition-transform hover:-translate-y-1" data-id="element-53">
              {/* Top tape piece */}
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 w-16 h-6 bg-[#e8e4df] border border-black/10 transform -rotate-2 shadow-sm" data-id="element-54"></div>

              <div className="flex items-center mb-4 border-b border-black/10 pb-3" data-id="element-55">
                <FileText className="w-5 h-5 text-black/60 mr-2" data-id="element-56" />
                <span className="font-mono text-xs font-bold text-black/60 uppercase tracking-widest" data-id="element-57">
                  Sujeto #{index + 1}
                </span>
              </div>

              <h4 className="text-lg font-mono font-bold text-black mb-3 uppercase leading-tight" data-id="element-58">
                Q: {faq.q}
              </h4>
              <p className="text-black/80 font-sans text-sm leading-relaxed" data-id="element-59">
                <strong className="font-mono text-noir-alert" data-id="element-60">A:</strong>{' '}
                {faq.a}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}